import { forwardRef } from "react";
import { Checkbox, CheckboxChangeEvent, CheckboxRef } from "antd";

import { BaseCheckboxProps } from "./types";
import BaseError from "../BaseError";

import "./styles.css";

const BaseCheckbox = forwardRef<CheckboxRef, BaseCheckboxProps>(
  (
    {
      label,
      checked,
      value,
      onChange,
      error,
      className,
      ...props
    }: BaseCheckboxProps,
    ref,
  ) => {
    const isChecked = checked !== undefined ? checked : value;

    const handleChange = (e: CheckboxChangeEvent) => {
      e.stopPropagation();
      onChange(e.target.checked);
    };

    return (
      <>
        <Checkbox
          className={`base-checkbox ${className || ""}`}
          checked={isChecked}
          onChange={handleChange}
          onClick={(e) => e.stopPropagation()}
          {...props}
          ref={ref}
        >
          {label}
        </Checkbox>
        <BaseError error={error} />
      </>
    );
  },
);

export default BaseCheckbox;
